import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import ConversationWorkflowsIndex from './index.vue';
import FlowEditor from './FlowEditor.vue';
import FlowExecutionsHistory from './FlowExecutionsHistory.vue';
import FlowExecutionDetail from './FlowExecutionDetail.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/conversation-workflows'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'conversation_workflows_index',
          component: ConversationWorkflowsIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/conversation-workflows/:workflowId/edit'
      ),
      name: 'conversation_workflows_edit',
      component: FlowEditor,
      meta: {
        permissions: ['administrator'],
      },
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/conversation-workflows/:workflowId/executions'
      ),
      name: 'conversation_workflows_executions',
      component: FlowExecutionsHistory,
      meta: {
        permissions: ['administrator'],
      },
    },
    {
      path: frontendURL(
        'accounts/:accountId/settings/conversation-workflows/:workflowId/executions/:executionId'
      ),
      name: 'conversation_workflows_execution_detail',
      component: FlowExecutionDetail,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
